export type SubscriptionPlan = "verified_trader" | "pro_seller";

const FALLBACK_PRICE_IDS: Record<SubscriptionPlan, string> = {
  verified_trader: "price_1Q...VerifiedTrader",
  pro_seller: "price_1Q...ProSeller",
};

export const SUBSCRIPTION_PRICE_IDS: Record<SubscriptionPlan, string> = {
  verified_trader:
    import.meta.env.VITE_STRIPE_PRICE_VERIFIED_TRADER ?? FALLBACK_PRICE_IDS.verified_trader,
  pro_seller: import.meta.env.VITE_STRIPE_PRICE_PRO_SELLER ?? FALLBACK_PRICE_IDS.pro_seller,
};
